import { mapGetters } from 'vuex';

export const PriceMaskMixin = {
    computed: {
        ...mapGetters(['currencySign']),

        money() {
            return {
                decimal: '.',
                thousands: '.',
                prefix: `${this.currencySign} `,
                precision: 2,
                masked: false
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/PriceMaskMixin.js